import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc, collection, addDoc, getDocs, query, orderBy, limit, deleteDoc } from 'firebase/firestore';

// GMG ACE Portal Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyDf3ZOQ2ywJ1uMgZ6kHGDWHSvZ8hcItjBQ",
  authDomain: "gmg-ace-portal.firebaseapp.com",
  projectId: "gmg-ace-portal",
  storageBucket: "gmg-ace-portal.firebasestorage.app",
  messagingSenderId: "648994073770",
  appId: "1:648994073770:web:2410c3eba94b24fe0574d3",
  measurementId: "G-RZJ81WFEEF"
};

let app, auth, db;
try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  
  // V2.12 FIX: Set persistence to LOCAL to prevent random logouts
  setPersistence(auth, browserLocalPersistence)
    .then(() => console.log('Firebase persistence set to LOCAL'))
    .catch((error) => console.warn('Persistence error:', error));
    
  console.log('Firebase initialized successfully');
} catch (error) {
  console.warn('Firebase init error:', error);
}

export const signInWithGoogle = async () => {
  if (!auth) {
    console.warn('Auth not available');
    return null;
  }
  try {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    
    // V2.12: Ensure persistence before sign in
    await setPersistence(auth, browserLocalPersistence);
    
    const result = await signInWithPopup(auth, provider);
    console.log('Sign in successful:', result.user.email);
    return result.user;
  } catch (error) {
    console.error('Sign in error:', error);
    return null;
  }
};

export const logOut = async () => {
  if (!auth) return;
  try {
    await signOut(auth);
    console.log('Sign out successful');
  } catch (error) {
    console.error('Sign out error:', error);
  }
};

export const saveToHistory = async (userId, entry) => {
  if (!db || !userId) return;
  try {
    await addDoc(collection(db, 'users', userId, 'history'), {
      ...entry,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    console.error('Save history error:', error);
  }
};

export const getHistory = async (userId) => {
  if (!db || !userId) return [];
  try {
    const q = query(
      collection(db, 'users', userId, 'history'),
      orderBy('timestamp', 'desc'),
      limit(50)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Get history error:', error);
    return [];
  }
};

export const saveTierLevel = async (userId, tier) => {
  if (!db || !userId) return;
  try {
    await setDoc(doc(db, 'users', userId), { tierLevel: tier }, { merge: true });
  } catch (error) {
    console.error('Save tier error:', error);
  }
};

export const getTierLevel = async (userId) => {
  if (!db || !userId) return 'free';
  try {
    const docSnap = await getDoc(doc(db, 'users', userId));
    return docSnap.exists() ? (docSnap.data().tierLevel || 'free') : 'free';
  } catch (error) {
    console.error('Get tier error:', error);
    return 'free';
  }
};

// V2.12: Delete knowledge entry
export const deleteKnowledgeEntry = async (entryId) => {
  if (!db || !entryId) return false;
  try {
    await deleteDoc(doc(db, 'knowledge', entryId));
    console.log('Knowledge entry deleted:', entryId);
    return true;
  } catch (error) {
    console.error('Delete knowledge error:', error);
    return false;
  }
};

export { auth, db, onAuthStateChanged };
